import { render, staticRenderFns } from "./Approbations.vue?vue&type=template&id=3a2e1292"
import script from "./Approbations.vue?vue&type=script&lang=js"
export * from "./Approbations.vue?vue&type=script&lang=js"
import style0 from "./Approbations.vue?vue&type=style&index=0&id=3a2e1292&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports